import logo from './logo.svg';
import './App.css';
import Login from './components/Admin/Login/Login';
import Admin from './components/Admin/Login/Admin';
import { BrowserRouter as Router, Route, Link, Routes } from "react-router-dom";
import Registration from './components/Admin/Registration/registration';
import Doctor from './components/Doctor/Doctor/Doctor';
import FamilyLogin from './components/Family/Login/Login';
import FamilySignup from './components/Family/Signup/Signup';
import FamilyOTP from './components/Family/OTP/Otp';
import FamilyHome from './components/Family/FamilyHome/FamilyHome';
import CareHome from './components/Admin/CareAdmin/CareHome/CareHome';
import Invoice from './components/Admin/CareAdmin/Invoice/Invoice';
import Forgot from './components/Admin/ForgotPassword/Forgot'
import StaffDetails from './components/Admin/Staff/StaffDetails';
import PatientList from './components/Admin/PatientList/PatientList';
import PatientHealth from './components/Admin/PatientHealthSD/PatientHealth';
import MedicationManage from './components/Family/MedicationManagement/MedicationManage';
import ActivityTracker from './components/Family/ActivityTracker/ActivityTracker';
import DietNutrition from './components/Family/DietNutrition/DietNutrition';
import HealthMonitoring from './components/Family/HealthMonitoring/HealthMonitoring';
import DoctorMedicationManagement from './components/Doctor/DoctorMedicationManagement/DoctorMedicationManagement';
import MessageChat from './components/Admin/ConversationsChat/MessageChat';
import ResidentHealthData from './components/Nurse/ResidentHealthData/ResidentHealthData';
import ResidentHealthDataView from './components/Nurse/ResidentHealthDataView/ResidentHealthDataView';
import Notification from './components/Nurse/Notifications/Notifications';
import Medications from './components/Nurse/Medications/Medications';
import Medication from './components/Admin/Medication/Medication';
import Alerts from './components/Nurse/Alerts/Alerts';

// Family Login 
import Logincheck from './components/Family/Login/FamilyMemberLoginCheck';
function App() {
  return (
    <>
    {/* <Login/> */}
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/family/login" element={<FamilyLogin />} />
        <Route path="/family/signup" element={<FamilySignup />} />
        <Route path="/family/otp" element={<FamilyOTP />} />
        <Route path="messagechat" element={<Registration />} />
        <Route path="/doctor" element={<Doctor />} />
        <Route path="/invoice" element={<Registration />} />
        <Route path="/forgot-password" element={<Forgot/>} />
        <Route path="/staff-details" element={<Registration/>} />
        <Route path='/family' element={<Logincheck/>}>
            <Route path="home" element={<FamilyHome />} />
            <Route path="medication-management" element={<Registration />} />
            <Route path="activity-tracker" element={<Registration />} />
            <Route path="diet-nutrition" element={<Registration />} />
            <Route path="health-monitoring" element={<Registration />} />
        </Route>
        <Route path="/admin" element={<Admin />} >
          <Route path="carehome" element={<CareHome />} />
          <Route path="registration/:id?" element={<Registration />} />
          <Route path="patient-list" element={<PatientList />} />
          <Route path="patient-health" element={<Registration />} />
          <Route path="doctor-medication-management" element={<Registration />} />
          <Route path="nurse/resident-health-data" element={<Registration />} />
          <Route path="nurse/resident-health-data-view" element={<Registration />} />
          <Route path="nurse/notification" element={<Registration />} />
          <Route path="nurse/medications" element={<Registration />} />
          <Route path="nurse/alerts" element={<Registration />} />
          <Route path="medication" element={<Registration />} />
        </Route>
      </Routes>
    </Router>
    </>
    
  );
}

export default App;
